// extracted by mini-css-extract-plugin
module.exports = {"base":"nwea-ds-v1-button-base","focus-override":"nwea-ds-v1-button-focus-override","push":"nwea-ds-v1-button-push"};